import { createSlice } from "@reduxjs/toolkit";

const initialLang = localStorage.getItem("currentLang") || "ro";

export const translationSlice = createSlice({
  name: "translation",
  initialState: {
    currentLanguage: initialLang,
  },
  reducers: {
    setCurrentLang: (state, action) => {
      state.currentLanguage = action.payload;
      localStorage.setItem("currentLang", action.payload);
      window.location.reload();
    },
  },
});

export const { setCurrentLang } = translationSlice.actions;

export default translationSlice.reducer;
